import * as PIXI from 'pixi.js';

export default class RotateableSpriteContainer extends PIXI.Container {
    constructor({ texture, width, height }) {
        super();

        this.meshWidth = width || texture.width;
        this.meshHeight = height || texture.height;

        this.perspectiveMesh = new PIXI.PerspectiveMesh({
            texture,
            pivot: {
                x: this.meshWidth / 2,
                y: this.meshHeight / 2,
            },
        });
        this.perspectiveMesh.setCorners(
            0, 0,
            this.meshWidth, 0,
            this.meshWidth, this.meshHeight,
            0, this.meshHeight,
        );
        this.addChild(this.perspectiveMesh);
    }

    rotate(angleX, angleY, perspective = 300) {
        let points = [
            { x: 0, y: 0 },
            { x: this.meshWidth, y: 0 },
            { x: this.meshWidth, y: this.meshHeight },
            { x: 0, y: this.meshHeight },
        ];
        
        let outPoints = points.map((p) => ({ ...p }));

        let radX = (angleX * Math.PI) / 180;
        let radY = (angleY * Math.PI) / 180;
        let cosX = Math.cos(radX);
        let sinX = Math.sin(radX);
        let cosY = Math.cos(radY);
        let sinY = Math.sin(radY);

        for (let i = 0; i < points.length; i++) {
            const src = points[i];
            const out = outPoints[i];
            const x = src.x - this.meshWidth / 2;
            const y = src.y - this.meshHeight / 2;
            let z = 0; // Assume initial z is 0 for this 2D plane

            // Rotate around Y axis
            const xY = cosY * x - sinY * z;

            z = sinY * x + cosY * z;

            // Rotate around X axis
            const yX = cosX * y - sinX * z;

            z = sinX * y + cosX * z;

            // Apply perspective projection
            const scale = perspective / (perspective - z);

            out.x = xY * scale + this.meshWidth / 2;
            out.y = yX * scale + this.meshHeight / 2;
        }

        this.perspectiveMesh.setCorners(
            outPoints[0].x, outPoints[0].y,
            outPoints[1].x, outPoints[1].y,
            outPoints[2].x, outPoints[2].y,
            outPoints[3].x, outPoints[3].y,
        );
    }
}